<template>
  <div id="dashboard-level1-biodata">
    <v-layout align-start justify-start row wrap>
      <v-flex sm12 class="text-xs-left">
        <v-btn
          :loading="isLoading"
          color="info"
          dark
          round
          outline
          class="elevation-1"
          @click="updateUser()"
        >
          <v-icon class="pr-2">edit</v-icon>Edit Profile
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card min-height="300px" class="my-2">
      <v-layout align-start justify-start row wrap>
        <v-flex md12>
          <table>
            <tr>
              <td>
                <v-img
                  class="ml-4 pa-1"
                  :src="currentMember.image"
                  width="230"
                  height="230"
                  contain
                  style="border:dashed 2px gray"
                ></v-img>
              </td>
              <td class="pl-3" style="vertical-align:top;">
                <table>
                  <tr>
                    <td style="width:100px;">No. Induk:</td>
                    <td>{{currentMember.no_induk}}</td>
                  </tr>
                  <tr>
                    <td style="width:70px;">Nama:</td>
                    <td>{{currentMember.name}}</td>
                  </tr>
                  <tr>
                    <td style="width:70px;">No HP:</td>
                    <td>{{currentMember.no_hp}}</td>
                  </tr>
                  <tr>
                    <td style="width:70px;">Tanggal Lahir:</td>
                    <td>{{currentMember.tanggal_lahir | date}}</td>
                  </tr>
                  <tr>
                    <td style="width:70px;">Umur:</td>
                    <td>{{currentMember.umur_tahun}} Tahun&nbsp;&nbsp;&nbsp;{{currentMember.umur_bulan}} Bulan</td>
                  </tr>
                  <tr>
                    <td style="width:125px;">Gender:</td>
                    <td>{{currentMember.jenis_kelamin}}</td>
                  </tr>
                  <tr>
                    <td style="width:100px;">Tingkat Pendidikan:</td>
                    <td>{{currentMember.tingkat_pendidikan}}</td>
                  </tr>
                  <tr>
                    <td style="width:125px;">Sekolah:</td>
                    <td>{{currentMember.sekolah}}</td>
                  </tr>

                  <tr>
                    <td style="width:100px;">Kelas:</td>
                    <td>{{currentMember.kelas}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-card>
    <dashboard-level1-biodata-update :param="updateBiodataParam"></dashboard-level1-biodata-update>
    <full-page-loading :value="isLoadingFullPage" message="Tunggu! sedang loading data"></full-page-loading>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { format } from "date-fns";
import { DATAMEMBER_SET_VALUE_ACTION } from "@/store/actions.type";

export default {
  components: {
    "dashboard-level1-biodata-update": () =>
      import("../Level1/DashboardLevel1BiodataUpdate"),
    "full-page-loading": () => import("../../../components/FullPageLoading")
  },
  data() {
    return {
      isLoading: false,
      isLoadingFullPage: false,
      updateBiodataParam: {
        showDialog: false,
        no_induk: "",
        name: "",
        tanggal_lahir: "",
        jenis_kelamin: "",
        sekolah: "",
        kelas: "",
        hasImage: "",
        image: {
          dataUrl: ""
        }
      }
    };
  },
  computed: {
    ...mapState({
      currentMember: state => state.auth.currentMember,
      currentUser: state => state.auth.user
    }),
    memberImageUrl: function() {
      return this.currentMember.image;
    }
  },
  filters: {
    date: function(value) {
      return format(new Date(value), "DD-MM-YYYY");
    }
  },
  mounted() {
    this.memberSetValue();
  },
  methods: {
    // sleep: function(duration) {
    //   return new Promise(resolve => {
    //     setTimeout(() => {
    //       resolve();
    //     }, duration * 1000);
    //   });
    // },
    updateUser: function() {
      this.isLoading = true;

      this.updateBiodataParam.showDialog = true;
      this.updateBiodataParam.id = this.currentUser.id;
      this.updateBiodataParam.no_induk = this.currentMember.no_induk;
      this.updateBiodataParam.name = this.currentMember.name;
      this.updateBiodataParam.no_hp = this.currentMember.no_hp;
      this.updateBiodataParam.tanggal_lahir = this.currentMember.tanggal_lahir;
      this.updateBiodataParam.jenis_kelamin =
      this.currentMember.jenis_kelamin === "Perempuan" ? "P" : "L";
      this.updateBiodataParam.sekolah = this.currentMember.sekolah;
      this.updateBiodataParam.kelas = this.currentMember.kelas;
      this.updateBiodataParam.hasImage = true;
      this.updateBiodataParam.image.dataUrl = this.currentMember.image;
      this.updateBiodataParam.tingkat_pendidikan = this.currentMember.tingkat_pendidikan;      
      this.isLoading = false;
    },
    memberSetValue: function() {
      this.isLoadingFullPage = true;
      this.$store
        .dispatch(DATAMEMBER_SET_VALUE_ACTION, {
          Id: this.currentUser.id
        })
        .then(() => {
          this.isLoadingFullPage = false;
        });
    }
  }
};
</script>